import { Button, Card } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import * as actions from '../../redux/actions';
import { useSocket } from '../../contexts/SocketContext';
import api from '../../utils/functions/api';
import HrcheckinList from '../../components/Table/HrcheckinList';
import FilterTimestampCard from '../../components/Card/FilterTimestampCard';

export default function HrTimestampList({ title, subtitle }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const timestamp = useSelector((state) => state.timestamp);
  const info = useSelector((state) => state.info);

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [emSelect, setEmSelect] = useState();
  const [dateStart, setDateStart] = useState(new Date());
  const [dateEnd, setDateEnd] = useState(new Date());
  const [allEmployees, setAllEmployees] = useState([]);

  useEffect(() => {
    dispatch(actions.timestampAll({ size, page, emSelect }));
    dispatch(actions.getInformation());
    return () => {};
  }, [page, size, emSelect]);

  useEffect(() => {
    const fetchAllEmployees = async () => {
      const PAGE_SIZE = 50;
      let pg = 1;
      let accumulated = [];
      let hasMore = true;
      while (hasMore) {
        const { data } = await api.get(
          `${process.env.REACT_APP_API_URL}/employee?name=&size=${PAGE_SIZE}&page=${pg}&activeOnly=false`,
        );
        const rows = data?.rows || [];
        const total = data?.total || 0;
        accumulated = [...accumulated, ...rows];
        setAllEmployees([...accumulated]);
        hasMore = accumulated.length < total && rows.length > 0;
        pg++;
      }
    };
    fetchAllEmployees();
  }, []);

  // Socket.IO real-time listeners
  const socket = useSocket();
  useEffect(() => {
    if (!socket) return;
    const refresh = () =>
      dispatch(actions.timestampAll({ size, page, emSelect }));

    socket.on('timestamp:created', refresh);
    socket.on('timestamp:updated', refresh);
    socket.on('timestamp:deleted', refresh);

    return () => {
      socket.off('timestamp:created', refresh);
      socket.off('timestamp:updated', refresh);
      socket.off('timestamp:deleted', refresh);
    };
  }, [socket, page, size, emSelect]);

  const renderCardQuery = () => (
    <div>
      <FilterTimestampCard
        employees={{ rows: allEmployees }}
        emSelect={emSelect}
        setEmSelect={setEmSelect}
        dateStart={dateStart}
        dateEnd={dateEnd}
        setDateStart={setDateStart}
        setDateEnd={setDateEnd}
      />
    </div>
  );

  const renderTable = () => (
    <HrcheckinList
      timestamp={timestamp}
      page={page}
      size={size}
      setPage={setPage}
      setSize={setSize}
      show={info?.setting?.timestamp_image}
    />
  );

  return (
    <div>
      <div className="py-1">{renderCardQuery()}</div>
      <div>{renderTable()}</div>
    </div>
  );
}
